import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-iac',
  imports: [CommonModule, RouterLink],
  templateUrl: './iac.html',
  styleUrl: './iac.css'
})
export class Iac {
  features = [
    {
      title: 'Terraform Automation',
      description: 'Multi-cloud infrastructure provisioning with Terraform for AWS, Azure, GCP, and hybrid environments.',
      icon: 'terraform'
    },
    {
      title: 'AWS CloudFormation',
      description: 'Native AWS infrastructure automation with CloudFormation templates and StackSets.',
      icon: 'cloudformation'
    },
    {
      title: 'Configuration Management',
      description: 'Ansible, Chef, and Puppet for automated server configuration and application deployment.',
      icon: 'config'
    },
    {
      title: 'GitOps Workflows',
      description: 'Version-controlled infrastructure with automated deployments through Git-based workflows.',
      icon: 'gitops'
    },
    {
      title: 'State Management',
      description: 'Secure remote state management with locking, versioning, and team collaboration support.',
      icon: 'state'
    },
    {
      title: 'Compliance as Code',
      description: 'Automated compliance checks and policy enforcement using Sentinel, OPA, and Cloud Custodian.',
      icon: 'compliance'
    }
  ];

  process = [
    { step: 1, title: 'Infrastructure Audit', description: 'Document existing infrastructure and identify opportunities for automation.' },
    { step: 2, title: 'IaC Strategy & Design', description: 'Design modular, reusable infrastructure code architecture.' },
    { step: 3, title: 'Migration & Implementation', description: 'Migrate infrastructure to code with comprehensive testing and validation.' },
    { step: 4, title: 'Training & Handoff', description: 'Train your team on IaC best practices and ongoing management.' }
  ];

  caseStudy = {
    client: 'HealthTech Solutions',
    industry: 'Healthcare Technology',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&h=500&fit=crop',
    challenge: 'HealthTech had inconsistent infrastructure across 15+ AWS accounts, with manual provisioning taking 2-3 weeks per environment. They struggled with HIPAA compliance auditing and environment drift.',
    solution: 'We migrated their entire infrastructure to Terraform with modular designs, implemented automated compliance scanning, and established GitOps workflows for infrastructure changes.',
    results: [
      { metric: '90%', description: 'Faster Environment Provisioning' },
      { metric: '100%', description: 'Infrastructure Consistency' },
      { metric: 'Zero', description: 'Configuration Drift Issues' },
      { metric: 'Automated', description: 'HIPAA Compliance Checks' }
    ]
  };

  testimonial = {
    quote: 'Infrastructure as Code completely changed how we manage our AWS environments. What used to take weeks now happens in minutes, and we have perfect consistency across all our accounts. The compliance automation alone saved us hundreds of hours during our last audit.',
    author: 'Dr. Sarah Williams',
    role: 'VP of Engineering',
    company: 'HealthTech Solutions',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop'
  };

  tools = [
    { name: 'Terraform', category: 'Multi-Cloud IaC' },
    { name: 'AWS CloudFormation', category: 'AWS Native' },
    { name: 'Ansible', category: 'Configuration Management' },
    { name: 'Pulumi', category: 'Modern IaC' },
    { name: 'Azure Resource Manager', category: 'Azure Native' },
    { name: 'Google Cloud Deployment Manager', category: 'GCP Native' },
    { name: 'Sentinel', category: 'Policy as Code' },
    { name: 'Terragrunt', category: 'Terraform Wrapper' }
  ];
}
